var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-between px-5"},[_c('font-awesome-icon',{staticClass:"hg-nav-btn cursor-pointer",attrs:{"icon":"fa-solid fa-arrow-left"},on:{"click":_vm.prevSlide}}),_c('font-awesome-icon',{staticClass:"hg-nav-btn cursor-pointer",attrs:{"icon":"fa-solid fa-arrow-right"},on:{"click":_vm.nextSlide}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }